<template>
    <div>
        <login title="Pb-Shop Admin" @login="checkLoginCredentials"></login>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {mapState, mapActions} from "vuex";
    import Login from "../components/Login";

    export default {
        name: "cmsLogin",
        components: {
            Login
        },
        computed: {
            ...mapState("account", ["status"]) // TODO why it is needed
        },
        methods: {
            ...mapActions("account", ["login"]),
            checkLoginCredentials({username, password, path}) {
                if (username && password && path) {
                    this.login({username, password}).then(() => this.$router.push("/cms"));
                }
            }
        }
    };
</script>

<style lang="scss">
    @import '~@shared/_assets/scss/admin.scss';
</style>
